export default __webpack_public_path__ + "static/artifakt-element-regular-5d4ece9f462cbd8cc9a3657d350d46db.woff2";